export default {
    topics: [
        {
            title: ' loadLibrary ',
            href: 'f-loadLibrary.html',
            attributes: { 'data-id': 'f-loadLibrary' },
            menu: { hasChildren: false },
            tocID: 'f-loadLibrary-d66e4551',
            topics: [],
        },
        {
            title: ' get ',
            href: 'f-get.html',
            attributes: { 'data-id': 'f-get' },
            menu: { hasChildren: false },
            tocID: 'f-get-d66e4559',
            topics: [],
        },
        {
            title: ' load ',
            href: 'f-load.html',
            attributes: { 'data-id': 'f-load' },
            menu: { hasChildren: false },
            tocID: 'f-load-d66e4567',
            topics: [],
        },
        {
            title: ' create ',
            href: 'f-create.html',
            attributes: { 'data-id': 'f-create' },
            menu: { hasChildren: false },
            tocID: 'f-create-d66e4575',
            topics: [],
        },
        {
            title: ' logon ',
            href: 'f-logon.html',
            attributes: { 'data-id': 'f-logon' },
            menu: { hasChildren: false },
            tocID: 'f-logon-d66e4583',
            topics: [],
        },
        {
            title: ' applyXsl ',
            href: 'f-applyXsl.html',
            attributes: { 'data-id': 'f-applyXsl' },
            menu: { hasChildren: false },
            tocID: 'f-applyXsl-d66e4591',
            topics: [],
        },
        {
            title: ' applyXslFromFile ',
            href: 'f-applyXslFromFile.html',
            attributes: { 'data-id': 'f-applyXslFromFile' },
            menu: { hasChildren: false },
            tocID: 'f-applyXslFromFile-d66e4599',
            topics: [],
        },
        {
            title: ' formatDate ',
            href: 'f-formatDate.html',
            attributes: { 'data-id': 'f-formatDate' },
            menu: { hasChildren: false },
            tocID: 'f-formatDate-d66e4607',
            topics: [],
        },
        {
            title: ' parseTimeStamp ',
            href: 'f-parseTimeStamp.html',
            attributes: { 'data-id': 'f-parseTimeStamp' },
            menu: { hasChildren: false },
            tocID: 'f-parseTimeStamp-d66e4615',
            topics: [],
        },
        {
            title: ' escapeXmlStr ',
            href: 'f-escapeXmlStr.html',
            attributes: { 'data-id': 'f-escapeXmlStr' },
            menu: { hasChildren: false },
            tocID: 'f-escapeXmlStr-d66e4623',
            topics: [],
        },
        {
            title: ' escapeUrl ',
            href: 'f-escapeUrl.html',
            attributes: { 'data-id': 'f-escapeUrl' },
            menu: { hasChildren: false },
            tocID: 'f-escapeUrl-d66e4631',
            topics: [],
        },
        {
            title: ' getUrl ',
            href: 'f-getUrl.html',
            attributes: { 'data-id': 'f-getUrl' },
            menu: { hasChildren: false },
            tocID: 'f-getUrl-d66e4640',
            topics: [],
        },
        {
            title: ' getUUID ',
            href: 'f-getUUID.html',
            attributes: { 'data-id': 'f-getUUID' },
            menu: { hasChildren: false },
            tocID: 'f-getUUID-d66e4648',
            topics: [],
        },
        {
            title: ' cryptString ',
            href: 'f-cryptString.html',
            attributes: { 'data-id': 'f-cryptString' },
            menu: { hasChildren: false },
            tocID: 'f-cryptString-d66e4656',
            topics: [],
        },
        {
            title: ' decryptString ',
            href: 'f-decryptString.html',
            attributes: { 'data-id': 'f-decryptString' },
            menu: { hasChildren: false },
            tocID: 'f-decryptString-d66e4664',
            topics: [],
        },
        {
            title: ' encryptDES ',
            href: 'f-encryptDES.html',
            attributes: { 'data-id': 'f-encryptDES' },
            menu: { hasChildren: false },
            tocID: 'f-encryptDES-d66e4672',
            topics: [],
        },
        {
            title: ' decryptDES ',
            href: 'f-decryptDES.html',
            attributes: { 'data-id': 'f-decryptDES' },
            menu: { hasChildren: false },
            tocID: 'f-decryptDES-d66e4680',
            topics: [],
        },
        {
            title: 'decryptPassword',
            href: 'f-decryptPassword.html',
            attributes: { 'data-id': 'f-getUrl' },
            menu: { hasChildren: false },
            tocID: 'f-getUrl-d66e4688',
            topics: [],
        },
        {
            title: ' DESencrypt ',
            href: 'f-DESencrypt.html',
            attributes: { 'data-id': 'f-DESencrypt' },
            menu: { hasChildren: false },
            tocID: 'f-DESencrypt-d66e4696',
            topics: [],
        },
        {
            title: ' DESdecrypt ',
            href: 'f-DESdecrypt.html',
            attributes: { 'data-id': 'f-DESdecrypt' },
            menu: { hasChildren: false },
            tocID: 'f-DESdecrypt-d66e4704',
            topics: [],
        },
        {
            title: ' obfuscate ',
            href: 'f-obfuscate.html',
            attributes: { 'data-id': 'f-obfuscate' },
            menu: { hasChildren: false },
            tocID: 'f-obfuscate-d66e4712',
            topics: [],
        },
        {
            title: ' unobfuscate ',
            href: 'f-unobfuscate.html',
            attributes: { 'data-id': 'f-unobfuscate' },
            menu: { hasChildren: false },
            tocID: 'f-unobfuscate-d66e4720',
            topics: [],
        },
        {
            title: ' generateTrackingTag ',
            href: 'f-generateTrackingTag.html',
            attributes: { 'data-id': 'f-generateTrackingTag' },
            menu: { hasChildren: false },
            tocID: 'f-generateTrackingTag-d66e4729',
            topics: [],
        },
        {
            title: ' generateImgTag ',
            href: 'f-generateImgTag.html',
            attributes: { 'data-id': 'f-generateImgTag' },
            menu: { hasChildren: false },
            tocID: 'f-generateImgTag-d66e4737',
            topics: [],
        },
        {
            title: ' getImageUrl ',
            href: 'f-getImageUrl.html',
            attributes: { 'data-id': 'f-getImageUrl' },
            menu: { hasChildren: false },
            tocID: 'f-getImageUrl-d66e4745',
            topics: [],
        },
        {
            title: ' digestStrMd5 ',
            href: 'f-digestStrMd5.html',
            attributes: { 'data-id': 'f-digestStrMd5' },
            menu: { hasChildren: false },
            tocID: 'f-digestStrMd5-d66e4753',
            topics: [],
        },
        {
            title: ' digestStrSha1 ',
            href: 'f-digestStrSha1.html',
            attributes: { 'data-id': 'f-digestStrSha1' },
            menu: { hasChildren: false },
            tocID: 'f-digestStrSha1-d66e4761',
            topics: [],
        },
        {
            title: ' digestStrSha224 ',
            href: 'f-digestStrSha224.html',
            attributes: { 'data-id': 'f-digestStrSha224' },
            menu: { hasChildren: false },
            tocID: 'f-digestStrSha224-d66e4769',
            topics: [],
        },
        {
            title: ' digestStrSha256 ',
            href: 'f-digestStrSha256.html',
            attributes: { 'data-id': 'f-digestStrSha256' },
            menu: { hasChildren: false },
            tocID: 'f-digestStrSha256-d66e4777',
            topics: [],
        },
        {
            title: ' digestStrSha384 ',
            href: 'f-digestStrSha384.html',
            attributes: { 'data-id': 'f-digestStrSha384' },
            menu: { hasChildren: false },
            tocID: 'f-digestStrSha384-d66e4785',
            topics: [],
        },
        {
            title: ' digestStrSha512 ',
            href: 'f-digestStrSha512.html',
            attributes: { 'data-id': 'f-digestStrSha512' },
            menu: { hasChildren: false },
            tocID: 'f-digestStrSha512-d66e4793',
            topics: [],
        },
        {
            title: ' hmacStr ',
            href: 'f-hmacStr.html',
            attributes: { 'data-id': 'f-hmacStr' },
            menu: { hasChildren: false },
            tocID: 'f-hmacStr-d66e4801',
            topics: [],
        },
    ],
};

